export const translations = {
  it: {
    nav: {
      home: "Home", esplora: "Esplora", esperienze: "Esperienze", echoes: "Echoes From Above",
      progetto: "Il Progetto", eventi: "Eventi", comuni: "Per Comuni e Partner", chisono: "Chi Sono", contatti: "Contatti",
    },
    common: {
      scopriBorgo: "Scopri il borgo", borgoLabel: "Borgo del Monferrato", esplora: "Esplora", scorri: "Scorri",
      apriMenu: "Apri menu", chiudiMenu: "Chiudi menu",
    },
    marquee: ["Borghi", "Paesaggi", "Storie", "Cinema", "Immersione", "Musica", "Monferrato"],
    home: {
      eyebrow: "Monferrato Immersive®",
      heroLine1: "Il Monferrato,", heroLine2: "come non lo hai", heroLine3: "mai visto.",
      heroSub: "Borghi, paesaggi e storie raccontati attraverso immagini cinematografiche, esperienze immersive a 360° e realtà virtuale.",
      ctaExplore: "Esplora il Monferrato", ctaExperience: "Vivi l'esperienza",
      territorio: {
        chapter: "01", eyebrow: "Il Territorio", titleA: "Un territorio", titleB: "da vivere.",
        body: "Il Monferrato è un patrimonio di paesaggi, borghi, storia e tradizioni. Monferrato Immersive nasce per raccontarlo attraverso immagini cinematografiche, esperienze a 360°, realtà virtuale e musica originale. Un modo nuovo di scoprire il territorio, viverlo e condividerne l'emozione.",
        concepts: [
          { t: "Riprese Cinematiche", d: "Drone, 360°, terra e storytelling visivo" },
          { t: "Esperienze Immersive", d: "Realtà Virtuale e video immersivi per tutti" },
          { t: "Visione Internazionale", d: "Contenuti multilingua per un pubblico globale" },
          { t: "Valore al Territorio", d: "Promozione, cultura, turismo e identità" },
        ],
        formula: "Territorio + Immagini + Immersione + Musica",
        imgAlt: "Veduta aerea di un borgo del Monferrato all'ora d'oro",
      },
      esplora: { chapter: "02", eyebrow: "I Borghi", title: "Esplora il Monferrato", subtitle: "Ogni borgo custodisce una storia." },
      esperienze: {
        chapter: "03", eyebrow: "L'Esperienza", titleA: "Non guardare soltanto.", titleB: "Entra nel Monferrato.",
        pillars: [
          { num: "01", t: "Video Cinematografici", d: "Storie raccontate attraverso la cinematografia aerea e le riprese da terra, nella luce più bella del giorno." },
          { num: "02", t: "Video 360°", d: "Esplora borghi e paesaggi da ogni direzione, con il controllo totale del punto di vista." },
          { num: "03", t: "Realtà Virtuale", d: "Vivi il Monferrato attraverso i visori VR, inclusi Meta Quest e le installazioni immersive dal vivo." },
        ],
        cta: "Scopri le esperienze immersive",
        questNote: "Le esperienze immersive di Monferrato Immersive possono essere vissute anche attraverso visori Meta Quest.",
      },
      mappa: {
        chapter: "04", eyebrow: "La Carta", title: "La carta dei borghi",
        body: "Un paesaggio di colline e geometrie da esplorare punto per punto. Seleziona un borgo per iniziare il viaggio.",
        note: "Carta illustrata — posizioni indicative dei borghi", selected: "Borgo selezionato",
      },
      suono: {
        chapter: "05", eyebrow: "Echoes From Above",
        titleA: "Ogni luogo ha un'immagine.", titleB: "Ogni immagine ha un suono.",
        body: "Le immagini di Monferrato Immersive sono accompagnate da musiche originali create per amplificare l'emozione del paesaggio. Echoes From Above è la dimensione musicale del progetto: composizioni nate per accompagnare il viaggio, dare voce ai luoghi e trasformare le immagini in esperienza.",
        highlight: "Immagini. Suono. Emozione.", cta: "Scopri Echoes From Above",
        imgAlt: "Echoes From Above — Living Memories, artwork ufficiale",
      },
      visione: {
        chapter: "06", eyebrow: "La Visione", title: "La nostra visione",
        body: "Vogliamo far vivere il Monferrato in modo nuovo, emozionante e accessibile a tutti, attraverso esperienze immersive che uniscono tecnologia e autenticità.",
        highlights: ["Raccontare il territorio.", "Coinvolgere le persone.", "Valorizzare il futuro."],
        pillars: [
          { t: "Per le persone", d: "Esperienze coinvolgenti per residenti e visitatori di ogni età." },
          { t: "Per il territorio", d: "Uno strumento innovativo per la promozione culturale e turistica." },
          { t: "Per il futuro", d: "Tecnologie sostenibili al servizio della cultura e dell'identità locale." },
        ],
      },
      final: { titleA: "Il Monferrato", titleB: "vi aspetta.", sub: "Scopritelo. Vivetelo. Condividetelo.", cta: "Esplora il Monferrato", imgAlt: "Il Monferrato all'ora d'oro" },
      heroAlt: "Il Monferrato al tramonto — borghi e vigne visti dal cielo",
    },
    esperienze: {
      eyebrow: "Esperienze", heroA: "Non guardare soltanto.", heroB: "Entra nel Monferrato.",
      heroSub: "Tre modi di attraversare il territorio: il cinema, l'esplorazione a 360° e la Realtà Virtuale.",
      chapters: [
        {
          num: "01", title: "Video Cinematografici",
          body: "Ogni borgo diventa un film: voli di drone all'ora d'oro, riprese da terra e montaggio cinematografico raccontano il territorio come un documentario emozionale, disponibile sul canale ufficiale e dentro ogni pagina borgo.",
          cta: "Guarda un film",
        },
        {
          num: "02", title: "Video 360°",
          body: "I video a 360° ti permettono di esplorare piazze, vicoli e belvedere in ogni direzione: sei tu a scegliere dove guardare, da computer, smartphone o tablet.",
          cta: "Prova un video 360°",
        },
        {
          num: "03", title: "Realtà Virtuale",
          body: "Con i visori VR come Meta Quest il borgo ti circonda completamente: le esperienze immersive di Monferrato Immersive possono essere vissute anche attraverso visori Meta Quest e durante gli eventi e le installazioni immersive sul territorio.",
          cta: "Vedi gli eventi",
        },
      ],
      closingTitle: "Il viaggio continua su YouTube.",
      closingBody: "Tutti i film e i video 360° dei borghi sono pubblicati sul canale ufficiale Monferrato Immersive.",
      ctaChannel: "Apri il canale YouTube", ctaBorghi: "Esplora i borghi",
    },
    echoes: {
      eyebrow: "La dimensione musicale di Monferrato Immersive®",
      heroA: "Echoes", heroB: "From Above", heroSub: "Il paesaggio diventa musica.",
      projLabel: "Il progetto",
      quote: "Non una semplice colonna sonora. Una parte del racconto.",
      dareTitle: "Dare un suono ai luoghi.",
      dareBody: "Echoes From Above nasce dall'idea che un territorio non debba soltanto essere osservato, ma possa essere ascoltato e percepito. Le composizioni originali accompagnano le immagini di Monferrato Immersive e contribuiscono a costruire l'identità emozionale di ogni racconto. Musica e immagini diventano così parti della stessa esperienza.",
      catalogoEyebrow: "Musica originale", catalogoTitle: "Il catalogo",
      catalogoBody: "Le composizioni di Echoes From Above nascono dall'incontro tra paesaggio e suono, e vivono anche oltre le immagini: il progetto ha una propria identità artistica indipendente. L'ascolto è disponibile sui canali ufficiali.",
      ascoltaEyebrow: "Ascolta e guarda",
      ascoltaTitleA: "Guarda il Monferrato.", ascoltaTitleB: "Ascolta la sua emozione.",
      ascoltaBody: "I film di Monferrato Immersive incontrano qui la musica originale: paesaggio, cinema e suono in un'unica esperienza.",
      filmsCta: "Echoes From Above su YouTube",
      platformsTitle: "Segui Echoes From Above",
      platformsSub: "I canali ufficiali del progetto musicale.",
      backHome: "Torna a Monferrato Immersive",
      imgAlt: "Borgo del Monferrato visto dal cielo",
    },
    progetto: {
      eyebrow: "Il Progetto", titleA: "Un territorio,", titleB: "quattro dimensioni.",
      heroSub: "Monferrato Immersive è un progetto indipendente dedicato a scoprire, raccontare e promuovere il Monferrato.",
      formulaEyebrow: "L'ecosistema creativo",
      formula: ["Territorio", "Immagini", "Immersione", "Musica"],
      formulaNote: "Non servizi separati, ma dimensioni diverse della stessa esperienza creativa.",
      dimEyebrow: "Le dimensioni", dimTitle: "Un unico sguardo, quattro linguaggi",
      dims: [
        { t: "Cinema", d: "Riprese con drone e racconto cinematografico del territorio." },
        { t: "Immersione", d: "Video a 360° ed esperienze di Realtà Virtuale." },
        { t: "Musica", d: "Composizioni originali di Echoes From Above." },
        { t: "Storytelling", d: "Storia, luoghi, persone e identità." },
      ],
      evoEyebrow: "In evoluzione", evoTitle: "Un progetto pensato per crescere",
      evoBody: "L'obiettivo è costruire una rete di esperienze immersive dedicate ai borghi del Monferrato, coinvolgendo Comuni, enti, associazioni e operatori turistici. Ogni nuova collaborazione amplia il patrimonio di contenuti e promuove il territorio con strumenti innovativi e accessibili.",
      evo: [
        { tag: "Oggi", items: ["Produzione video", "Esperienze VR", "Riprese drone"] },
        { tag: "Domani", items: ["Collaborazioni istituzionali", "Contenuti multilingua", "Esperienze immersive permanenti"] },
        { tag: "Obiettivo", items: ["Far conoscere il Monferrato attraverso esperienze che lasciano il segno."] },
      ],
      cta: "Collabora con il progetto",
    },
    eventi: {
      eyebrow: "Eventi", titleA: "Esperienze", titleB: "dal vivo.",
      heroSub: "Il Monferrato da vivere di persona: fiere, installazioni immersive ed esperienze di Realtà Virtuale.",
      listEyebrow: "Prossimi appuntamenti", listTitle: "Dove incontrarci",
      note: "Nuovi eventi ed esperienze saranno annunciati qui.",
      standLine: "Stand immersivo · video 360° · Realtà Virtuale",
      pastEyebrow: "Archivio",
      pastTitle: "Eventi passati – Il nostro percorso",
      pastBadge: "Evento concluso",
    },
    eventsText: {
      "botteghe-storiche-mercatini-casale-2026": {
        title: "Botteghe Storiche – Mercatini 2026",
        date: "8 Novembre 2026",
        location: "Casale Monferrato, Piemonte, Italia",
        category: "Mercatini · Esperienza immersiva",
        description: "Monferrato Immersive® partecipa ai Mercatini delle Botteghe Storiche di Casale Monferrato con le proprie esperienze immersive. Un'occasione per scoprire i borghi e i paesaggi del Monferrato attraverso video cinematografici, riprese a 360° e realtà virtuale.",
      },
      "fiera-nazionale-del-tartufo-di-moncalvo-2026": {
        title: "Fiera Nazionale del Tartufo di Moncalvo — 72ª Edizione",
        date: "18 · 24 · 25 Ottobre 2026",
        location: "Moncalvo — Centro storico",
        category: "Fiera del territorio · Esperienza immersiva",
        description: "Monferrato Immersive ha partecipato alla 72ª Fiera Nazionale del Tartufo di Moncalvo con il proprio stand immersivo, offrendo ai visitatori l'opportunità di scoprire il Monferrato attraverso contenuti cinematografici, video a 360° ed esperienze di Realtà Virtuale.",
        linkLabel: "Sito ufficiale della Fiera",
      },
    },
    partner: {
      eyebrow: "Per Comuni, Enti e Partner", titleA: "Raccontiamo insieme", titleB: "il territorio.",
      heroSub: "Monferrato Immersive collabora con chi custodisce e promuove il territorio, portando borghi e paesaggi dentro un'esperienza cinematografica e immersiva.",
      perChiEyebrow: "Per chi", perChiTitle: "Un progetto aperto",
      audiences: ["Comuni", "Enti", "Associazioni", "Pro Loco", "Operatori turistici", "Strutture ricettive", "Aziende", "Partner territoriali"],
      capabilities: [
        "Storytelling cinematografico del territorio", "Riprese con drone", "Riprese immersive a 360°",
        "Esperienze di Realtà Virtuale", "Racconto multilingua", "Installazioni immersive per eventi",
        "Esperienze immersive permanenti", "Contenuti promozionali per il territorio",
      ],
      formEyebrow: "Contatto professionale", formTitleA: "Parliamo del", formTitleB: "tuo territorio.",
      formBody: "Raccontaci il tuo Comune, la tua realtà o la tua idea: valuteremo insieme come trasformarla in un'esperienza cinematografica e immersiva.",
      quote: "Il territorio è il protagonista. La tecnologia è il mezzo.",
    },
    chisono: {
      eyebrow: "Chi Sono", titleA: "Chi c'è dietro", titleB: "Monferrato Immersive",
      role: "Ideatore di Monferrato Immersive",
      storyEyebrow: "La storia", storyTitleA: "Uno sguardo nuovo", storyTitleB: "sulla propria terra.",
      bio: [
        "Mi chiamo Giorgio Panatero e sono l'ideatore di Monferrato Immersive. Da sempre sono affascinato dalla capacità delle immagini di raccontare un territorio e trasmettere emozioni.",
        "Con questo progetto ho deciso di unire la mia passione per la tecnologia, la fotografia aerea e la realtà virtuale per creare un nuovo modo di valorizzare il Monferrato.",
        "Ogni video nasce da un'attenta ricerca sul territorio, da riprese realizzate sul campo e dalla volontà di offrire ai visitatori un'esperienza autentica, capace di trasformare la curiosità in desiderio di scoperta.",
        "Monferrato Immersive è un progetto in continua evoluzione, aperto alla collaborazione con Comuni, enti, associazioni e realtà che condividono l'obiettivo di promuovere e valorizzare questo straordinario territorio.",
        "Le musiche originali che accompagnano i video nascono anche dal mio progetto musicale Echoes From Above: un'identità artistica indipendente che contribuisce all'ecosistema creativo di Monferrato Immersive, dando voce all'emozione e all'unicità di ogni luogo.",
      ],
      quote1: "Ogni borgo custodisce una storia.", quote2: "Il mio obiettivo è renderla un'esperienza.",
      cta: "Parliamone",
      portraitAlt: "Giorgio Panatero — ideatore di Monferrato Immersive",
      fieldAlt: "Giorgio Panatero durante le riprese sul territorio",
    },
    contatti: {
      eyebrow: "Contatti", titleA: "Scriviamo insieme", titleB: "il prossimo capitolo.",
      emailLabel: "Email", channelsLabel: "Canali ufficiali",
      formEyebrow: "Modulo di contatto", formTitle: "Raccontaci la tua idea",
    },
    form: {
      name: "Nome e Cognome", namePh: "Il tuo nome",
      org: "Organizzazione / Comune / Azienda",
      email: "Email", phone: "Telefono", optional: "Facoltativo",
      interest: "Tipo di interesse", interestPlaceholder: "Seleziona…",
      interests: ["Comune / Ente", "Associazione / Pro Loco", "Operatore turistico", "Struttura ricettiva", "Azienda / Partner", "Altro"],
      message: "Messaggio", messagePh: "Raccontaci il tuo territorio o la tua idea…",
      privacy: "Ho letto e accetto il trattamento dei dati personali per essere ricontattato in merito alla mia richiesta.",
      privacyError: "È necessario accettare l'informativa privacy.",
      submit: "Invia la richiesta", sending: "Invio in corso…",
      successTitle: "Grazie per il tuo messaggio.",
      successBody: "La tua richiesta è stata registrata. Ti ricontatteremo all'indirizzo email indicato.",
      successToast: "Richiesta inviata. Ti risponderemo al più presto.",
      error: "Invio non riuscito. Scrivici a monferratoimmersive@gmail.com",
    },
    footer: {
      tagline: "Il Monferrato, come non lo hai mai visto.",
      explore: "Esplora", progetto: "Il Progetto",
      borghi: "I Borghi", esperienze: "Esperienze Immersive", mappa: "La Mappa",
      visione: "Visione ed ecosistema", eventi: "Eventi", partner: "Per Comuni e Partner",
      chisono: "Chi Sono", contatti: "Contatti",
      efaDesc: "La dimensione musicale di Monferrato Immersive.",
      efaProject: "Il progetto musicale",
      copyright: "© 2026 Giorgio Panatero – Monferrato Immersive®. Tutti i diritti riservati.",
    },
    village: {
      filmEyebrow: "Guarda il film", filmTitle: "Il borgo in movimento",
      filmPlay: "Guarda il film",
      filmNote: "Film cinematografico ufficiale di Monferrato Immersive.",
      panoEyebrow: "Vivi il borgo a 360°", panoTitle: "Guarda in ogni direzione.",
      panoPlay: "Avvia il video 360°",
      panoNote: "Trascina il video per guardarti intorno: sei tu a scegliere la direzione dello sguardo.",
      storyEyebrow: "Scopri il borgo",
      storyWip: "Il racconto di {name} nasce dal territorio: dal volo del drone, dalla luce dei suoi paesaggi e dalla curiosità di chi lo attraversa per la prima volta.",
      borgoOf: "Borgo {n} — Monferrato",
      condividi: "Condividi l'esperienza", copiato: "Link copiato",
      copiedToast: "Link copiato negli appunti.",
      prev: "Borgo precedente", next: "Borgo successivo",
      notFound: "Questo borgo non è ancora sulla mappa.",
      backToBorghi: "Torna ai borghi",
      galleryAlt: "fotografia aerea",
      filmAlt: "fotogramma dal volo", panoAlt: "anteprima panoramica",
    },
    villagesText: {
      "moncalvo": { tagline: "Un anfiteatro di tetti e colline nella luce del Monferrato.", short: "Torri, bastioni e un orizzonte che si perde tra le colline, raccontato dal volo del drone." },
      "vignale-monferrato": { tagline: "Il colle che guarda le vigne, dove ogni strada porta al cielo.", short: "Un profilo di tetti e campanili sospeso tra i filari, visto dall'alto." },
      "rosignano-monferrato": { tagline: "Pietra, silenzio e orizzonti che respirano.", short: "Un borgo arroccato che domina la valle, colto nella luce radente del giorno." },
      "murisengo": { tagline: "Boschi, colline e un profilo che domina la valle.", short: "Tetti di cotto e verde profondo in una coreografia vista dal cielo." },
      "ottiglio": { tagline: "La pietra dorata accarezzata dalla luce del mattino.", short: "Un abbraccio di case e colline, dove il tempo scorre con passo lento." },
      "cocconato": { tagline: "Un belvedere naturale sospeso tra cielo e vigneti.", short: "Il borgo si distende sul colle come un veliero tra le onde verdi." },
      "calliano-monferrato": { tagline: "Colline gentili e tetti che raccontano il tempo.", short: "Un intreccio di strade, corti e orizzonti aperti sulla valle." },
      "grazzano-badoglio": { tagline: "Un balcone sul Monferrato, tra verde e geometrie di tetti.", short: "Il borgo osservato dal cielo, tra il campanile e l'orizzonte delle colline." },
    },
    seo: {
      home: { t: "Monferrato Immersive® — Il Monferrato, come non lo hai mai visto", d: "Borghi, paesaggi e storie del Monferrato raccontati attraverso immagini cinematografiche, video a 360°, realtà virtuale e musiche originali." },
      esperienze: { t: "Esperienze Immersive — Monferrato Immersive®", d: "Video cinematografici, video a 360° e Realtà Virtuale per entrare nel Monferrato." },
      echoes: { t: "Echoes From Above — La dimensione musicale di Monferrato Immersive®", d: "Il paesaggio diventa musica: composizioni originali che danno voce ai luoghi del Monferrato." },
      progetto: { t: "Il Progetto — Monferrato Immersive®", d: "Territorio, immagini, immersione e musica: la visione di Monferrato Immersive." },
      eventi: { t: "Eventi ed Esperienze dal Vivo — Monferrato Immersive®", d: "Fiere, installazioni immersive ed esperienze di Realtà Virtuale nel Monferrato." },
      partner: { t: "Per Comuni e Partner — Monferrato Immersive®", d: "Raccontiamo insieme il territorio: storytelling cinematografico, riprese drone, video 360° e Realtà Virtuale per Comuni e partner." },
      chisono: { t: "Chi c'è dietro Monferrato Immersive — Giorgio Panatero", d: "Giorgio Panatero, ideatore di Monferrato Immersive: tecnologia, fotografia aerea, cinema e musica per il territorio." },
      contatti: { t: "Contatti — Monferrato Immersive®", d: "Contatta Monferrato Immersive per collaborazioni, eventi ed esperienze immersive sul territorio." },
      village: { t: "{name} — Monferrato Immersive®", d: "Scopri {name} nel Monferrato: film cinematografico, video a 360° e Realtà Virtuale." },
    },
  },

  en: {
    nav: {
      home: "Home", esplora: "Explore", esperienze: "Experiences", echoes: "Echoes From Above",
      progetto: "The Project", eventi: "Events", comuni: "For Municipalities & Partners", chisono: "About", contatti: "Contact",
    },
    common: {
      scopriBorgo: "Discover the village", borgoLabel: "Village of Monferrato", esplora: "Explore", scorri: "Scroll",
      apriMenu: "Open menu", chiudiMenu: "Close menu",
    },
    marquee: ["Villages", "Landscapes", "Stories", "Cinema", "Immersion", "Music", "Monferrato"],
    home: {
      eyebrow: "Monferrato Immersive®",
      heroLine1: "Monferrato,", heroLine2: "as you have", heroLine3: "never seen it.",
      heroSub: "Villages, landscapes and stories told through cinematic imagery, 360° immersive experiences and virtual reality.",
      ctaExplore: "Explore Monferrato", ctaExperience: "Live the experience",
      territorio: {
        chapter: "01", eyebrow: "The Territory", titleA: "A land", titleB: "to be lived.",
        body: "Monferrato is a heritage of landscapes, villages, history and traditions. Monferrato Immersive was born to tell its story through cinematic imagery, 360° experiences, virtual reality and original music. A new way to discover the territory, live it and share its emotion.",
        concepts: [
          { t: "Cinematic Filming", d: "Drone, 360°, ground and visual storytelling" },
          { t: "Immersive Experiences", d: "Virtual Reality and immersive video for everyone" },
          { t: "International Vision", d: "Multilingual content for a global audience" },
          { t: "Value for the Territory", d: "Promotion, culture, tourism and identity" },
        ],
        formula: "Territory + Images + Immersion + Music",
        imgAlt: "Aerial view of a Monferrato village at golden hour",
      },
      esplora: { chapter: "02", eyebrow: "The Villages", title: "Explore Monferrato", subtitle: "Every village guards a story." },
      esperienze: {
        chapter: "03", eyebrow: "The Experience", titleA: "Don't just watch.", titleB: "Step into Monferrato.",
        pillars: [
          { num: "01", t: "Cinematic Video", d: "Stories told through aerial cinematography and ground footage, in the most beautiful light of day." },
          { num: "02", t: "360° Video", d: "Explore villages and landscapes from every direction, with full control of your point of view." },
          { num: "03", t: "Virtual Reality", d: "Experience Monferrato through VR headsets, including Meta Quest and live immersive installations." },
        ],
        cta: "Discover the immersive experiences",
        questNote: "Monferrato Immersive experiences can also be enjoyed through Meta Quest headsets.",
      },
      mappa: {
        chapter: "04", eyebrow: "The Map", title: "The map of villages",
        body: "A landscape of hills and geometries to explore point by point. Select a village to begin the journey.",
        note: "Illustrated map — indicative village positions", selected: "Selected village",
      },
      suono: {
        chapter: "05", eyebrow: "Echoes From Above",
        titleA: "Every place has an image.", titleB: "Every image has a sound.",
        body: "The imagery of Monferrato Immersive is accompanied by original music created to amplify the emotion of the landscape. Echoes From Above is the musical dimension of the project: compositions born to accompany the journey, give voice to places and turn images into experience.",
        highlight: "Images. Sound. Emotion.", cta: "Discover Echoes From Above",
        imgAlt: "Echoes From Above — Living Memories, official artwork",
      },
      visione: {
        chapter: "06", eyebrow: "The Vision", title: "Our vision",
        body: "We want people to experience Monferrato in a new, exciting way accessible to everyone, through immersive experiences that unite technology and authenticity.",
        highlights: ["Telling the territory.", "Engaging people.", "Valuing the future."],
        pillars: [
          { t: "For people", d: "Engaging experiences for residents and visitors of all ages." },
          { t: "For the territory", d: "An innovative tool for cultural and tourism promotion." },
          { t: "For the future", d: "Sustainable technologies at the service of culture and local identity." },
        ],
      },
      final: { titleA: "Monferrato", titleB: "awaits you.", sub: "Discover it. Live it. Share it.", cta: "Explore Monferrato", imgAlt: "Monferrato at golden hour" },
      heroAlt: "Monferrato at sunset — villages and vineyards seen from the sky",
    },
    esperienze: {
      eyebrow: "Experiences", heroA: "Don't just watch.", heroB: "Step into Monferrato.",
      heroSub: "Three ways to cross the territory: cinema, 360° exploration and Virtual Reality.",
      chapters: [
        {
          num: "01", title: "Cinematic Video",
          body: "Every village becomes a film: golden-hour drone flights, ground footage and cinematic editing tell the territory like an emotional documentary, available on the official channel and inside every village page.",
          cta: "Watch a film",
        },
        {
          num: "02", title: "360° Video",
          body: "360° videos let you explore squares, alleys and belvederes in every direction: you choose where to look, from a computer, smartphone or tablet.",
          cta: "Try a 360° video",
        },
        {
          num: "03", title: "Virtual Reality",
          body: "With VR headsets such as Meta Quest the village surrounds you completely: Monferrato Immersive experiences can also be enjoyed through Meta Quest headsets and during immersive events and installations across the territory.",
          cta: "See the events",
        },
      ],
      closingTitle: "The journey continues on YouTube.",
      closingBody: "All village films and 360° videos are published on the official Monferrato Immersive channel.",
      ctaChannel: "Open the YouTube channel", ctaBorghi: "Explore the villages",
    },
    echoes: {
      eyebrow: "The musical dimension of Monferrato Immersive®",
      heroA: "Echoes", heroB: "From Above", heroSub: "The landscape becomes music.",
      projLabel: "The project",
      quote: "Not a simple soundtrack. A part of the story.",
      dareTitle: "Giving places a sound.",
      dareBody: "Echoes From Above is born from the idea that a territory should not only be observed, but can be listened to and perceived. The original compositions accompany the images of Monferrato Immersive and help build the emotional identity of every story. Music and images thus become parts of the same experience.",
      catalogoEyebrow: "Original music", catalogoTitle: "The catalogue",
      catalogoBody: "Echoes From Above compositions are born from the meeting of landscape and sound, and live beyond the images too: the project has its own independent artistic identity. Listening is available on the official channels.",
      ascoltaEyebrow: "Listen and watch",
      ascoltaTitleA: "Watch Monferrato.", ascoltaTitleB: "Listen to its emotion.",
      ascoltaBody: "Monferrato Immersive films meet original music here: landscape, cinema and sound in a single experience.",
      filmsCta: "Echoes From Above on YouTube",
      platformsTitle: "Follow Echoes From Above",
      platformsSub: "The official channels of the music project.",
      backHome: "Back to Monferrato Immersive",
      imgAlt: "Monferrato village seen from the sky",
    },
    progetto: {
      eyebrow: "The Project", titleA: "One territory,", titleB: "four dimensions.",
      heroSub: "Monferrato Immersive is an independent project dedicated to discovering, telling and promoting Monferrato.",
      formulaEyebrow: "The creative ecosystem",
      formula: ["Territory", "Images", "Immersion", "Music"],
      formulaNote: "Not separate services, but different dimensions of the same creative experience.",
      dimEyebrow: "The dimensions", dimTitle: "A single gaze, four languages",
      dims: [
        { t: "Cinema", d: "Drone filming and cinematic storytelling of the territory." },
        { t: "Immersion", d: "360° video and Virtual Reality experiences." },
        { t: "Music", d: "Original compositions by Echoes From Above." },
        { t: "Storytelling", d: "History, places, people and identity." },
      ],
      evoEyebrow: "Evolving", evoTitle: "A project designed to grow",
      evoBody: "The goal is to build a network of immersive experiences dedicated to the villages of Monferrato, involving municipalities, institutions, associations and tourism operators. Every new collaboration expands the heritage of content and promotes the territory with innovative, accessible tools.",
      evo: [
        { tag: "Today", items: ["Video production", "VR experiences", "Drone filming"] },
        { tag: "Tomorrow", items: ["Institutional collaborations", "Multilingual content", "Permanent immersive experiences"] },
        { tag: "Goal", items: ["To make Monferrato known through experiences that leave a mark."] },
      ],
      cta: "Collaborate with the project",
    },
    eventi: {
      eyebrow: "Events", titleA: "Live", titleB: "experiences.",
      heroSub: "Monferrato to experience in person: fairs, immersive installations and Virtual Reality experiences.",
      listEyebrow: "Upcoming events", listTitle: "Where to meet us",
      note: "New events and experiences will be announced here.",
      standLine: "Immersive stand · 360° video · Virtual Reality",
      pastEyebrow: "Archive",
      pastTitle: "Past Events – Our Journey",
      pastBadge: "Past event",
    },
    eventsText: {
      "botteghe-storiche-mercatini-casale-2026": {
        title: "Botteghe Storiche – Mercatini 2026",
        date: "November 8, 2026",
        location: "Casale Monferrato, Piedmont, Italy",
        category: "Market fair · Immersive experience",
        description: "Monferrato Immersive® takes part in the Botteghe Storiche markets in Casale Monferrato with its immersive experiences. An opportunity to discover the villages and landscapes of Monferrato through cinematic videos, 360° footage and virtual reality.",
      },
      "fiera-nazionale-del-tartufo-di-moncalvo-2026": {
        title: "Moncalvo National Truffle Fair — 72nd Edition",
        date: "18 · 24 · 25 October 2026",
        location: "Moncalvo — Historic centre",
        category: "Territory fair · Immersive experience",
        description: "Monferrato Immersive took part in the 72nd Moncalvo National Truffle Fair with its immersive stand, offering visitors the opportunity to discover Monferrato through cinematic content, 360° video and Virtual Reality experiences.",
        linkLabel: "Official Fair website",
      },
    },
    partner: {
      eyebrow: "For Municipalities, Institutions and Partners", titleA: "Let's tell the story", titleB: "of the territory together.",
      heroSub: "Monferrato Immersive collaborates with those who protect and promote the territory, bringing villages and landscapes into a cinematic and immersive experience.",
      perChiEyebrow: "For whom", perChiTitle: "An open project",
      audiences: ["Municipalities", "Institutions", "Associations", "Pro Loco", "Tourism operators", "Accommodation", "Companies", "Territorial partners"],
      capabilities: [
        "Cinematic territorial storytelling", "Drone filming", "360° immersive filming",
        "Virtual Reality experiences", "Multilingual storytelling", "Immersive event installations",
        "Permanent immersive experiences", "Promotional territorial content",
      ],
      formEyebrow: "Professional contact", formTitleA: "Let's talk about", formTitleB: "your territory.",
      formBody: "Tell us about your municipality, your organisation or your idea: together we will consider how to turn it into a cinematic and immersive experience.",
      quote: "The territory is the protagonist. Technology is the medium.",
    },
    chisono: {
      eyebrow: "About", titleA: "Who is behind", titleB: "Monferrato Immersive",
      role: "Creator of Monferrato Immersive",
      storyEyebrow: "The story", storyTitleA: "A new gaze", storyTitleB: "on one's own land.",
      bio: [
        "My name is Giorgio Panatero and I am the creator of Monferrato Immersive. I have always been fascinated by the power of images to tell the story of a territory and convey emotions.",
        "With this project I decided to unite my passion for technology, aerial photography and virtual reality to create a new way of enhancing Monferrato.",
        "Every video is born from careful research on the territory, from footage shot in the field and from the desire to offer visitors an authentic experience, capable of turning curiosity into a desire to discover.",
        "Monferrato Immersive is a constantly evolving project, open to collaboration with municipalities, institutions, associations and organisations that share the goal of promoting and enhancing this extraordinary territory.",
        "The original music accompanying the videos also comes from my music project Echoes From Above: an independent artistic identity that contributes to the Monferrato Immersive creative ecosystem, giving voice to the emotion and uniqueness of every place.",
      ],
      quote1: "Every village guards a story.", quote2: "My goal is to turn it into an experience.",
      cta: "Let's talk about it",
      portraitAlt: "Giorgio Panatero — creator of Monferrato Immersive",
      fieldAlt: "Giorgio Panatero filming in the field",
    },
    contatti: {
      eyebrow: "Contact", titleA: "Let's write", titleB: "the next chapter together.",
      emailLabel: "Email", channelsLabel: "Official channels",
      formEyebrow: "Contact form", formTitle: "Tell us your idea",
    },
    form: {
      name: "Full name", namePh: "Your name",
      org: "Organisation / Municipality / Company",
      email: "Email", phone: "Phone", optional: "Optional",
      interest: "Type of interest", interestPlaceholder: "Select…",
      interests: ["Municipality / Institution", "Association / Pro Loco", "Tourism operator", "Accommodation", "Company / Partner", "Other"],
      message: "Message", messagePh: "Tell us about your territory or your idea…",
      privacy: "I have read and accept the processing of my personal data in order to be contacted about my request.",
      privacyError: "You must accept the privacy notice.",
      submit: "Send the request", sending: "Sending…",
      successTitle: "Thank you for your message.",
      successBody: "Your request has been registered. We will contact you back at the email address provided.",
      successToast: "Request sent. We will reply as soon as possible.",
      error: "Sending failed. Write to us at monferratoimmersive@gmail.com",
    },
    footer: {
      tagline: "Monferrato, as you have never seen it.",
      explore: "Explore", progetto: "The Project",
      borghi: "The Villages", esperienze: "Immersive Experiences", mappa: "The Map",
      visione: "Vision and ecosystem", eventi: "Events", partner: "For Municipalities & Partners",
      chisono: "About", contatti: "Contact",
      efaDesc: "The musical dimension of Monferrato Immersive.",
      efaProject: "The music project",
      copyright: "© 2026 Giorgio Panatero – Monferrato Immersive®. All rights reserved.",
    },
    village: {
      filmEyebrow: "Watch the film", filmTitle: "The village in motion",
      filmPlay: "Watch the film",
      filmNote: "Official Monferrato Immersive cinematic film.",
      panoEyebrow: "Experience the village in 360°", panoTitle: "Look in every direction.",
      panoPlay: "Start the 360° video",
      panoNote: "Drag the video to look around: you choose where to look.",
      storyEyebrow: "Discover the village",
      storyWip: "The story of {name} is born from the territory: from the drone's flight, from the light of its landscapes and from the curiosity of those who cross it for the first time.",
      borgoOf: "Village {n} — Monferrato",
      condividi: "Share the experience", copiato: "Link copied",
      copiedToast: "Link copied to clipboard.",
      prev: "Previous village", next: "Next village",
      notFound: "This village is not on the map yet.",
      backToBorghi: "Back to the villages",
      galleryAlt: "aerial photograph",
      filmAlt: "frame from the flight", panoAlt: "panoramic preview",
    },
    villagesText: {
      "moncalvo": { tagline: "An amphitheatre of rooftops and hills in the light of Monferrato.", short: "Towers, ramparts and a horizon lost among the hills, told by the drone's flight." },
      "vignale-monferrato": { tagline: "The hill that watches over the vineyards, where every road leads to the sky.", short: "A skyline of rooftops and bell towers suspended among the vine rows, seen from above." },
      "rosignano-monferrato": { tagline: "Stone, silence and horizons that breathe.", short: "A perched village overlooking the valley, caught in the slanting light of day." },
      "murisengo": { tagline: "Woods, hills and a skyline that overlooks the valley.", short: "Terracotta rooftops and deep green in a choreography seen from the sky." },
      "ottiglio": { tagline: "Golden stone caressed by the morning light.", short: "An embrace of houses and hills, where time flows at a slow pace." },
      "cocconato": { tagline: "A natural belvedere suspended between sky and vineyards.", short: "The village stretches along its hill like a sailing ship among green waves." },
      "calliano-monferrato": { tagline: "Gentle hills and rooftops that tell the passing of time.", short: "A weave of streets, courtyards and open horizons over the valley." },
      "grazzano-badoglio": { tagline: "A balcony over Monferrato, between greenery and geometries of rooftops.", short: "The village observed from the sky, between the bell tower and the horizon of hills." },
    },
    seo: {
      home: { t: "Monferrato Immersive® — Monferrato, as you have never seen it", d: "Villages, landscapes and stories of Monferrato told through cinematic imagery, 360° video, virtual reality and original music." },
      esperienze: { t: "Immersive Experiences — Monferrato Immersive®", d: "Cinematic video, 360° video and Virtual Reality to step into Monferrato." },
      echoes: { t: "Echoes From Above — The musical dimension of Monferrato Immersive®", d: "The landscape becomes music: original compositions giving voice to the places of Monferrato." },
      progetto: { t: "The Project — Monferrato Immersive®", d: "Territory, images, immersion and music: the vision of Monferrato Immersive." },
      eventi: { t: "Events and Live Experiences — Monferrato Immersive®", d: "Fairs, immersive installations and Virtual Reality experiences in Monferrato." },
      partner: { t: "For Municipalities and Partners — Monferrato Immersive®", d: "Let's tell the territory together: cinematic storytelling, drone filming, 360° video and Virtual Reality for municipalities and partners." },
      chisono: { t: "Who is behind Monferrato Immersive — Giorgio Panatero", d: "Giorgio Panatero, creator of Monferrato Immersive: technology, aerial photography, cinema and music for the territory." },
      contatti: { t: "Contact — Monferrato Immersive®", d: "Contact Monferrato Immersive for collaborations, events and immersive experiences across the territory." },
      village: { t: "{name} — Monferrato Immersive®", d: "Discover {name} in Monferrato: cinematic film, 360° video and Virtual Reality." },
    },
  },

  fr: {
    nav: {
      home: "Accueil", esplora: "Explorer", esperienze: "Expériences", echoes: "Echoes From Above",
      progetto: "Le Projet", eventi: "Événements", comuni: "Communes & Partenaires", chisono: "Qui je suis", contatti: "Contact",
    },
    common: {
      scopriBorgo: "Découvrir le village", borgoLabel: "Village du Monferrato", esplora: "Explorer", scorri: "Défiler",
      apriMenu: "Ouvrir le menu", chiudiMenu: "Fermer le menu",
    },
    marquee: ["Villages", "Paysages", "Histoires", "Cinéma", "Immersion", "Musique", "Monferrato"],
    home: {
      eyebrow: "Monferrato Immersive®",
      heroLine1: "Le Monferrato,", heroLine2: "comme vous ne l'avez", heroLine3: "jamais vu.",
      heroSub: "Villages, paysages et histoires racontés à travers des images cinématographiques, des expériences immersives à 360° et la réalité virtuelle.",
      ctaExplore: "Explorer le Monferrato", ctaExperience: "Vivre l'expérience",
      territorio: {
        chapter: "01", eyebrow: "Le Territoire", titleA: "Un territoire", titleB: "à vivre.",
        body: "Le Monferrato est un patrimoine de paysages, de villages, d'histoire et de traditions. Monferrato Immersive naît pour le raconter à travers des images cinématographiques, des expériences à 360°, la réalité virtuelle et la musique originale. Une nouvelle façon de découvrir le territoire, de le vivre et d'en partager l'émotion.",
        concepts: [
          { t: "Prises Cinématographiques", d: "Drone, 360°, terre et récit visuel" },
          { t: "Expériences Immersives", d: "Réalité Virtuelle et vidéos immersives pour tous" },
          { t: "Vision Internationale", d: "Contenus multilingues pour un public mondial" },
          { t: "Valeur au Territoire", d: "Promotion, culture, tourisme et identité" },
        ],
        formula: "Territoire + Images + Immersion + Musique",
        imgAlt: "Vue aérienne d'un village du Monferrato à l'heure dorée",
      },
      esplora: { chapter: "02", eyebrow: "Les Villages", title: "Explorer le Monferrato", subtitle: "Chaque village garde une histoire." },
      esperienze: {
        chapter: "03", eyebrow: "L'Expérience", titleA: "Ne vous contentez pas de regarder.", titleB: "Entrez dans le Monferrato.",
        pillars: [
          { num: "01", t: "Vidéos Cinématographiques", d: "Des histoires racontées par la cinématographie aérienne et les prises de vue au sol, dans la plus belle lumière du jour." },
          { num: "02", t: "Vidéos 360°", d: "Explorez villages et paysages dans toutes les directions, avec un contrôle total du point de vue." },
          { num: "03", t: "Réalité Virtuelle", d: "Vivez le Monferrato à travers des casques VR, notamment Meta Quest et des installations immersives en direct." },
        ],
        cta: "Découvrir les expériences immersives",
        questNote: "Les expériences immersives de Monferrato Immersive peuvent également être vécues avec des casques Meta Quest.",
      },
      mappa: {
        chapter: "04", eyebrow: "La Carte", title: "La carte des villages",
        body: "Un paysage de collines et de géométries à explorer point par point. Sélectionnez un village pour commencer le voyage.",
        note: "Carte illustrée — positions indicatives des villages", selected: "Village sélectionné",
      },
      suono: {
        chapter: "05", eyebrow: "Echoes From Above",
        titleA: "Chaque lieu a une image.", titleB: "Chaque image a un son.",
        body: "Les images de Monferrato Immersive sont accompagnées de musiques originales créées pour amplifier l'émotion du paysage. Echoes From Above est la dimension musicale du projet : des compositions nées pour accompagner le voyage, donner une voix aux lieux et transformer les images en expérience.",
        highlight: "Images. Son. Émotion.", cta: "Découvrir Echoes From Above",
        imgAlt: "Echoes From Above — Living Memories, pochette officielle",
      },
      visione: {
        chapter: "06", eyebrow: "La Vision", title: "Notre vision",
        body: "Nous voulons faire vivre le Monferrato d'une manière nouvelle, émouvante et accessible à tous, à travers des expériences immersives qui unissent technologie et authenticité.",
        highlights: ["Raconter le territoire.", "Impliquer les personnes.", "Valoriser l'avenir."],
        pillars: [
          { t: "Pour les personnes", d: "Des expériences immersives pour les résidents et les visiteurs de tout âge." },
          { t: "Pour le territoire", d: "Un outil innovant pour la promotion culturelle et touristique." },
          { t: "Pour l'avenir", d: "Des technologies durables au service de la culture et de l'identité locale." },
        ],
      },
      final: { titleA: "Le Monferrato", titleB: "vous attend.", sub: "Découvrez-le. Vivez-le. Partagez-le.", cta: "Explorer le Monferrato", imgAlt: "Le Monferrato à l'heure dorée" },
      heroAlt: "Le Monferrato au coucher du soleil — villages et vignes vus du ciel",
    },
    esperienze: {
      eyebrow: "Expériences", heroA: "Ne vous contentez pas de regarder.", heroB: "Entrez dans le Monferrato.",
      heroSub: "Trois façons de traverser le territoire : le cinéma, l'exploration à 360° et la Réalité Virtuelle.",
      chapters: [
        {
          num: "01", title: "Vidéos Cinématographiques",
          body: "Chaque village devient un film : vols de drone à l'heure dorée, prises de vue au sol et montage cinématographique racontent le territoire comme un documentaire émotionnel, disponible sur la chaîne officielle et dans chaque page de village.",
          cta: "Regarder un film",
        },
        {
          num: "02", title: "Vidéos 360°",
          body: "Les vidéos à 360° vous permettent d'explorer places, ruelles et belvédères dans toutes les directions : c'est vous qui choisissez où regarder, depuis un ordinateur, un smartphone ou une tablette.",
          cta: "Essayer une vidéo 360°",
        },
        {
          num: "03", title: "Réalité Virtuelle",
          body: "Avec des casques VR comme Meta Quest, le village vous entoure complètement : les expériences immersives de Monferrato Immersive peuvent aussi être vécues avec des casques Meta Quest et lors d'événements et d'installations immersives sur le territoire.",
          cta: "Voir les événements",
        },
      ],
      closingTitle: "Le voyage continue sur YouTube.",
      closingBody: "Tous les films et vidéos 360° des villages sont publiés sur la chaîne officielle Monferrato Immersive.",
      ctaChannel: "Ouvrir la chaîne YouTube", ctaBorghi: "Explorer les villages",
    },
    echoes: {
      eyebrow: "La dimension musicale de Monferrato Immersive®",
      heroA: "Echoes", heroB: "From Above", heroSub: "Le paysage devient musique.",
      projLabel: "Le projet",
      quote: "Pas une simple bande-son. Une partie du récit.",
      dareTitle: "Donner un son aux lieux.",
      dareBody: "Echoes From Above naît de l'idée qu'un territoire ne doit pas seulement être observé, mais peut être écouté et perçu. Les compositions originales accompagnent les images de Monferrato Immersive et contribuent à construire l'identité émotionnelle de chaque récit. Musique et images deviennent ainsi parties de la même expérience.",
      catalogoEyebrow: "Musique originale", catalogoTitle: "Le catalogue",
      catalogoBody: "Les compositions d'Echoes From Above naissent de la rencontre entre paysage et son, et vivent aussi au-delà des images : le projet a sa propre identité artistique indépendante. L'écoute est disponible sur les canaux officiels.",
      ascoltaEyebrow: "Écouter et regarder",
      ascoltaTitleA: "Regardez le Monferrato.", ascoltaTitleB: "Écoutez son émotion.",
      ascoltaBody: "Les films de Monferrato Immersive rencontrent ici la musique originale : paysage, cinéma et son dans une seule expérience.",
      filmsCta: "Echoes From Above sur YouTube",
      platformsTitle: "Suivre Echoes From Above",
      platformsSub: "Les canaux officiels du projet musical.",
      backHome: "Retour à Monferrato Immersive",
      imgAlt: "Village du Monferrato vu du ciel",
    },
    progetto: {
      eyebrow: "Le Projet", titleA: "Un territoire,", titleB: "quatre dimensions.",
      heroSub: "Monferrato Immersive est un projet indépendant dédié à découvrir, raconter et promouvoir le Monferrato.",
      formulaEyebrow: "L'écosystème créatif",
      formula: ["Territoire", "Images", "Immersion", "Musique"],
      formulaNote: "Pas des services séparés, mais des dimensions différentes de la même expérience créative.",
      dimEyebrow: "Les dimensions", dimTitle: "Un seul regard, quatre langages",
      dims: [
        { t: "Cinéma", d: "Prises de vue par drone et récit cinématographique du territoire." },
        { t: "Immersion", d: "Vidéos à 360° et expériences de Réalité Virtuelle." },
        { t: "Musique", d: "Compositions originales d'Echoes From Above." },
        { t: "Storytelling", d: "Histoire, lieux, personnes et identité." },
      ],
      evoEyebrow: "En évolution", evoTitle: "Un projet pensé pour grandir",
      evoBody: "L'objectif est de construire un réseau d'expériences immersives dédiées aux villages du Monferrato, en impliquant communes, institutions, associations et opérateurs touristiques. Chaque nouvelle collaboration élargit le patrimoine de contenus et promeut le territoire avec des outils innovants et accessibles.",
      evo: [
        { tag: "Aujourd'hui", items: ["Production vidéo", "Expériences VR", "Prises de vue par drone"] },
        { tag: "Demain", items: ["Collaborations institutionnelles", "Contenus multilingues", "Expériences immersives permanentes"] },
        { tag: "Objectif", items: ["Faire connaître le Monferrato à travers des expériences qui laissent une trace."] },
      ],
      cta: "Collaborer avec le projet",
    },
    eventi: {
      eyebrow: "Événements", titleA: "Expériences", titleB: "en direct.",
      heroSub: "Le Monferrato à vivre en personne : foires, installations immersives et expériences de Réalité Virtuelle.",
      listEyebrow: "Prochains rendez-vous", listTitle: "Où nous rencontrer",
      note: "De nouveaux événements et expériences seront annoncés ici.",
      standLine: "Stand immersif · vidéo 360° · Réalité Virtuelle",
      pastEyebrow: "Archives",
      pastTitle: "Événements passés – Notre parcours",
      pastBadge: "Événement terminé",
    },
    eventsText: {
      "botteghe-storiche-mercatini-casale-2026": {
        title: "Botteghe Storiche – Mercatini 2026",
        date: "8 novembre 2026",
        location: "Casale Monferrato, Piémont, Italie",
        category: "Marchés · Expérience immersive",
        description: "Monferrato Immersive® participe aux Marchés des Botteghe Storiche de Casale Monferrato avec ses expériences immersives. Une occasion de découvrir les villages et les paysages du Monferrato à travers des vidéos cinématographiques, des prises de vue à 360° et la réalité virtuelle.",
      },
      "fiera-nazionale-del-tartufo-di-moncalvo-2026": {
        title: "Foire Nationale de la Truffe de Moncalvo — 72e édition",
        date: "18 · 24 · 25 octobre 2026",
        location: "Moncalvo — Centre historique",
        category: "Foire du territoire · Expérience immersive",
        description: "Monferrato Immersive a participé à la 72e Foire Nationale de la Truffe de Moncalvo avec son stand immersif, offrant aux visiteurs l'opportunité de découvrir le Monferrato à travers des contenus cinématographiques, des vidéos à 360° et des expériences de Réalité Virtuelle.",
        linkLabel: "Site officiel de la Foire",
      },
    },
    partner: {
      eyebrow: "Pour les Communes, Institutions et Partenaires", titleA: "Racontons ensemble", titleB: "le territoire.",
      heroSub: "Monferrato Immersive collabore avec ceux qui protègent et promeuvent le territoire, en portant villages et paysages dans une expérience cinématographique et immersive.",
      perChiEyebrow: "Pour qui", perChiTitle: "Un projet ouvert",
      audiences: ["Communes", "Institutions", "Associations", "Pro Loco", "Opérateurs touristiques", "Hébergements", "Entreprises", "Partenaires territoriaux"],
      capabilities: [
        "Récit cinématographique du territoire", "Prises de vue par drone", "Films immersifs à 360°",
        "Expériences de Réalité Virtuelle", "Récit multilingue", "Installations immersives pour événements",
        "Expériences immersives permanentes", "Contenus promotionnels du territoire",
      ],
      formEyebrow: "Contact professionnel", formTitleA: "Parlons de", formTitleB: "votre territoire.",
      formBody: "Parlez-nous de votre commune, de votre réalité ou de votre idée : nous étudierons ensemble comment la transformer en une expérience cinématographique et immersive.",
      quote: "Le territoire est le protagoniste. La technologie est le moyen.",
    },
    chisono: {
      eyebrow: "Qui je suis", titleA: "Qui se cache derrière", titleB: "Monferrato Immersive",
      role: "Concepteur de Monferrato Immersive",
      storyEyebrow: "L'histoire", storyTitleA: "Un regard nouveau", storyTitleB: "sur sa propre terre.",
      bio: [
        "Je m'appelle Giorgio Panatero et je suis le créateur de Monferrato Immersive. J'ai toujours été fasciné par la capacité des images à raconter un territoire et à transmettre des émotions.",
        "Avec ce projet, j'ai décidé d'unir ma passion pour la technologie, la photographie aérienne et la réalité virtuelle afin de créer une nouvelle façon de valoriser le Monferrato.",
        "Chaque vidéo naît d'une recherche attentive sur le territoire, de prises de vue réalisées sur le terrain et de la volonté d'offrir aux visiteurs une expérience authentique, capable de transformer la curiosité en désir de découverte.",
        "Monferrato Immersive est un projet en constante évolution, ouvert à la collaboration avec les communes, les institutions, les associations et les réalités qui partagent l'objectif de promouvoir et de valoriser ce territoire extraordinaire.",
        "Les musiques originales qui accompagnent les vidéos naissent aussi de mon projet musical Echoes From Above : une identité artistique indépendante qui contribue à l'écosystème créatif de Monferrato Immersive, en donnant une voix à l'émotion et à l'unicité de chaque lieu.",
      ],
      quote1: "Chaque village garde une histoire.", quote2: "Mon objectif est d'en faire une expérience.",
      cta: "Parlons-en",
      portraitAlt: "Giorgio Panatero — créateur de Monferrato Immersive",
      fieldAlt: "Giorgio Panatero pendant les prises de vue sur le terrain",
    },
    contatti: {
      eyebrow: "Contact", titleA: "Écrivons ensemble", titleB: "le prochain chapitre.",
      emailLabel: "Email", channelsLabel: "Canaux officiels",
      formEyebrow: "Formulaire de contact", formTitle: "Parlez-nous de votre idée",
    },
    form: {
      name: "Nom et prénom", namePh: "Votre nom",
      org: "Organisation / Commune / Entreprise",
      email: "Email", phone: "Téléphone", optional: "Facultatif",
      interest: "Type d'intérêt", interestPlaceholder: "Sélectionner…",
      interests: ["Commune / Institution", "Association / Pro Loco", "Opérateur touristique", "Hébergement", "Entreprise / Partenaire", "Autre"],
      message: "Message", messagePh: "Parlez-nous de votre territoire ou de votre idée…",
      privacy: "J'ai lu et j'accepte le traitement de mes données personnelles afin d'être recontacté au sujet de ma demande.",
      privacyError: "Vous devez accepter la politique de confidentialité.",
      submit: "Envoyer la demande", sending: "Envoi en cours…",
      successTitle: "Merci pour votre message.",
      successBody: "Votre demande a été enregistrée. Nous vous recontacterons à l'adresse email indiquée.",
      successToast: "Demande envoyée. Nous vous répondrons au plus vite.",
      error: "Échec de l'envoi. Écrivez-nous à monferratoimmersive@gmail.com",
    },
    footer: {
      tagline: "Le Monferrato, comme vous ne l'avez jamais vu.",
      explore: "Explorer", progetto: "Le Projet",
      borghi: "Les Villages", esperienze: "Expériences Immersives", mappa: "La Carte",
      visione: "Vision et écosystème", eventi: "Événements", partner: "Communes & Partenaires",
      chisono: "Qui je suis", contatti: "Contact",
      efaDesc: "La dimension musicale de Monferrato Immersive.",
      efaProject: "Le projet musical",
      copyright: "© 2026 Giorgio Panatero – Monferrato Immersive®. Tous droits réservés.",
    },
    village: {
      filmEyebrow: "Regarder le film", filmTitle: "Le village en mouvement",
      filmPlay: "Regarder le film",
      filmNote: "Film cinématographique officiel de Monferrato Immersive.",
      panoEyebrow: "Vivez le village à 360°", panoTitle: "Regardez dans toutes les directions.",
      panoPlay: "Lancer la vidéo 360°",
      panoNote: "Faites glisser la vidéo pour regarder autour de vous : c'est vous qui choisissez la direction du regard.",
      storyEyebrow: "Découvrir le village",
      storyWip: "Le récit de {name} naît du territoire : du vol du drone, de la lumière de ses paysages et de la curiosité de ceux qui le traversent pour la première fois.",
      borgoOf: "Village {n} — Monferrato",
      condividi: "Partager l'expérience", copiato: "Lien copié",
      copiedToast: "Lien copié dans le presse-papiers.",
      prev: "Village précédent", next: "Village suivant",
      notFound: "Ce village n'est pas encore sur la carte.",
      backToBorghi: "Retour aux villages",
      galleryAlt: "photographie aérienne",
      filmAlt: "image du vol", panoAlt: "aperçu panoramique",
    },
    villagesText: {
      "moncalvo": { tagline: "Un amphithéâtre de toits et de collines dans la lumière du Monferrato.", short: "Tours, remparts et un horizon qui se perd entre les collines, raconté par le vol du drone." },
      "vignale-monferrato": { tagline: "La colline qui veille sur les vignes, où chaque route mène au ciel.", short: "Un profil de toits et de clochers suspendu entre les rangées de vignes, vu d'en haut." },
      "rosignano-monferrato": { tagline: "Pierre, silence et horizons qui respirent.", short: "Un village perché qui domine la vallée, saisi dans la lumière rasante du jour." },
      "murisengo": { tagline: "Bois, collines et un profil qui domine la vallée.", short: "Toits de tuiles et vert profond dans une chorégraphie vue du ciel." },
      "ottiglio": { tagline: "La pierre dorée caressée par la lumière du matin.", short: "Une étreinte de maisons et de collines, où le temps s'écoule lentement." },
      "cocconato": { tagline: "Un belvédère naturel suspendu entre ciel et vignes.", short: "Le village s'étend sur la colline comme un voilier entre les vagues vertes." },
      "calliano-monferrato": { tagline: "Collines douces et toits qui racontent le temps.", short: "Un tissu de rues, de cours et d'horizons ouverts sur la vallée." },
      "grazzano-badoglio": { tagline: "Un balcon sur le Monferrato, entre verdure et géométries de toits.", short: "Le village observé du ciel, entre le clocher et l'horizon des collines." },
    },
    seo: {
      home: { t: "Monferrato Immersive® — Le Monferrato, comme vous ne l'avez jamais vu", d: "Villages, paysages et histoires du Monferrato racontés à travers des images cinématographiques, des vidéos 360°, la réalité virtuelle et des musiques originales." },
      esperienze: { t: "Expériences Immersives — Monferrato Immersive®", d: "Vidéos cinématographiques, vidéos 360° et Réalité Virtuelle pour entrer dans le Monferrato." },
      echoes: { t: "Echoes From Above — La dimension musicale de Monferrato Immersive®", d: "Le paysage devient musique : des compositions originales qui donnent une voix aux lieux du Monferrato." },
      progetto: { t: "Le Projet — Monferrato Immersive®", d: "Territoire, images, immersion et musique : la vision de Monferrato Immersive." },
      eventi: { t: "Événements et Expériences en Direct — Monferrato Immersive®", d: "Foires, installations immersives et expériences de Réalité Virtuelle dans le Monferrato." },
      partner: { t: "Communes et Partenaires — Monferrato Immersive®", d: "Racontons ensemble le territoire : récit cinématographique, prises de vue par drone, vidéos 360° et Réalité Virtuelle pour communes et partenaires." },
      chisono: { t: "Qui se cache derrière Monferrato Immersive — Giorgio Panatero", d: "Giorgio Panatero, créateur de Monferrato Immersive : technologie, photographie aérienne, cinéma et musique pour le territoire." },
      contatti: { t: "Contact — Monferrato Immersive®", d: "Contactez Monferrato Immersive pour des collaborations, événements et expériences immersives sur le territoire." },
      village: { t: "{name} — Monferrato Immersive®", d: "Découvrez {name} dans le Monferrato : film cinématographique, vidéo 360° et Réalité Virtuelle." },
    },
  },
};
